import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ROUTE_SUBSCRIPTION } from '@/router/routes';

interface Props {
  image: string;
  mobileImage: string;
}

export const RatingsPaywallBanner: React.FC<Props> = ({
  image,
  mobileImage,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToSubscription = () => navigate(ROUTE_SUBSCRIPTION);

  return (
    <>
      <div className="flex items-center gap-6 overflow-hidden rounded-xl bg-popover p-6 shadow-card md:hidden">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <h3 className="text-title-24 text-foreground">
            {t('overview.ratings.paywall.mobileTitle')}
          </h3>
          <p className="text-body-13 text-subtle-foreground">
            {t('overview.ratings.paywall.mobileDescription')}{' '}
            <button
              type="button"
              onClick={goToSubscription}
              className="cursor-pointer text-body-13 text-primary"
            >
              {t('overview.ratings.paywall.readMore')}
            </button>
          </p>
        </div>
        <img src={mobileImage} alt="" className="w-[84px] shrink-0" />
      </div>

      <div className="relative hidden overflow-hidden rounded-2xl bg-popover shadow-card md:block min-[1290px]:min-h-[280px]">
        <div className="relative z-10 flex flex-col gap-3 p-8 pb-0 min-[1290px]:max-w-[440px] min-[1290px]:pb-8">
          <h3 className="text-title-24 text-foreground">
            {t('overview.ratings.paywall.title')}
          </h3>
          <p className="text-body-16 text-muted-foreground">
            {t('overview.ratings.paywall.description')}
          </p>
        </div>
        <div
          aria-hidden
          className="pointer-events-none relative z-0 flex items-center justify-end p-8 min-[1290px]:absolute min-[1290px]:inset-y-0 min-[1290px]:right-0 min-[1290px]:left-[42%] min-[1290px]:p-0 min-[1290px]:pr-[17px]"
        >
          <div className="absolute inset-x-6 inset-y-8 rounded-2xl bg-info-surface opacity-50 blur-[80px] dark:opacity-20" />
          <img
            src={image}
            alt=""
            className="relative w-full max-w-[634px] object-contain object-right min-[1290px]:max-h-full"
          />
        </div>
      </div>
    </>
  );
};
